
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../app-context';
import IDialogComponent from '../../components/dialog/i-dialog.component';
import IGridComponent from '../../components/grid/i-grid.component';
import TitlePanel from '../../components/title-panel/title-panel.component';
import { EMPTY_STRING, PAGE_SIZE} from '../common/constants';
import './master-data-pending-list.component.scss';
import { getPendingMasterData, approveMasterData } from './masterdata.services';
import SpecsComponent from './specs/specs.component';
import { formatDate } from '../common/util.services';
import { Link } from 'react-router-dom';

const MasterDataPendingList = () => {
  const appContext = useContext(AppContext);
  const [role, setRole] = useState<String>('USER');
  const rows: GridRowsProp = [];
  const [masterData, setMasterData] = useState(rows);
  const [open, setOpen] = useState(false);
  const [rowData, setRowData] = useState(null);
  const columns: GridColDef[] = [
    { field: 'type', headerName: 'Type', filterable: false, sortable: false, width: 80 },
    { field: 'input', headerName: 'Input', filterable: false, sortable: false, width: 85 },
    { field: 'code', headerName: 'Code', filterable: false, sortable: false, width: 90 },
    { field: 'description', headerName: 'Description', filterable: false, sortable: false, width: 150 },
    {
      field: 'specs', headerName: 'Specs', filterable: false, sortable: false, width: 70,
      renderCell: (params) => {
        return <div className="cell-link" onClick={() => { openSpecsPopup(params) }}>Specs</div>
      }
    },
    { field: 'uom', headerName: 'UOM', filterable: false, sortable: false, width: 70 },
    { field: 'currency', headerName: 'Currency', filterable: false, sortable: false, width: 80 },
    { field: 'unitCost', headerName: 'Cost', filterable: false, sortable: false, width: 65 },
    { field: 'quoteLink', headerName: 'Quote', filterable: false, sortable: false, width: 90,
      renderCell: (params) => { return params.row.quoteLink.includes('drive.google.com') ?
                                (<Link to={params.row.quoteLink} target="_blank">Quote</Link>) : 'NA' }
    },
    { field: 'supplier', headerName: 'Supplier', width: 100, filterable: false, sortable: false },
    { field: 'version', headerName: 'Version', filterable: false, sortable: false, width: 70 },
    { field: 'moq', headerName: 'MOQ', filterable: false, sortable: false, width: 70 },
    {
      field: 'processLossPercentage', headerName: 'Proc Loss',
      valueFormatter: (processLossPercentage: any) => processLossPercentage + '%', filterable: false, sortable: false, width: 80
    },
    { field: 'updateDate', headerName: 'Date', filterable: false, sortable: false, 
      valueFormatter: (updateDate: any) => formatDate(updateDate), width: 90
    },
    { field: 'remarks', headerName: 'Remarks', filterable: false, sortable: false, width: 85 }
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    setLoading(true);
    if (appContext.userData) {
      setRole(appContext.userData.role);
    }
    getPendingMasterData(page, pageSize, appContext,
      (response: any) => {
        setMasterData(response.data.content);
        setTotalRows(response.data.totalElements);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        setLoading(false);
      });
  }, [page, pageSize]);

  const handleApproveAction = (row: any) => {
    approveMasterData(row.rowId, appContext,
      (response: any) => {
        setMasterData(masterData.filter((r) => r.rowId !== row.rowId));
        appContext.setSuccessMessage(response.message)
        appContext.setShowLoader(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message)
      });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const openSpecsPopup = (params: any) => {
    setRowData(params.row);
    setOpen(true);
  }

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const getMainPanel = () => {
    return <>
      <IGridComponent title={EMPTY_STRING} rows={masterData} columns={columns} loading={loading}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
        showAction={'ADMIN' === role || 'LFHADMIN' === role} handleApproveAction={handleApproveAction} 
        showApproveAction={true} showDeleteAction={false} showAddAction={false} showEditAction={false} showAddBtn={false}
        getRowId={(row: any) => row.rowId}/>
    </>
  }

  return <div className="master-data">
    <TitlePanel title='Data Approval' panelBody={getMainPanel()} />
    <IDialogComponent onClose={handleClose} open={open} title='Specifications' dialogClass={'spec-panel'} 
    dialogBody={<SpecsComponent data={rowData} />} />
  </div>
}

export default MasterDataPendingList;